import Vue from 'vue';
  
  const state = {
    display: false,
    content: {
        message:'',
        alt: ''
    },
    cb: ()=>{
      console.log('Im a callback')
    },
    altCb: ()=>{
      console.log('Im an alt callback')
    }
  }
  
  
  const actions = {
    open_banner_infos: (context,payload)=>{
        context.commit('open_banner_infos',payload);
    },
    close_banner_infos: context=>{
        context.commit('close_banner_infos');
    }
  };
  
  const mutations = {
    open_banner_infos: (state,payload)=>{

      const bannerInfos ={
            content:{
                message: payload.message || '',
                alt: payload.alt || ''
            },
            cb: payload.cb || '',
            altCb: payload.altCb || ''
        }
        Vue.set(state,'display',true);
        Vue.set(state,'content',bannerInfos.content);
        Vue.set(state,'cb',bannerInfos.cb);
    },
    close_banner_infos: state=>{
        Vue.set(state,'display',false);
    }
  }
  
  export default {
    state,
    actions,
    mutations
  }